import script from "./one.vue?vue&type=script&setup=true&lang=js"
export * from "./one.vue?vue&type=script&setup=true&lang=js"

import "./one.vue?vue&type=style&index=0&id=0c8f7abc&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c8f7abc"]])

export default __exports__